import { useQuery, useMutation } from '@tanstack/react-query';
import api from '../lib/axios';

export function useLlmProviders() {
  return useQuery({
    queryKey: ['llm-providers'],
    queryFn: async () => {
      const { data } = await api.get('/llm/providers');
      return data;
    },
  });
}

export function useTestProvider() {
  return useMutation({
    mutationFn: async (provider) => {
      const { data } = await api.post('/llm/test', { provider });
      return data;
    },
  });
}
